import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Wrapper = (props) => {
    if (props.wrapper === true) return (<>{props.children}</>)

    return (<div data-test-id="privacypolicy-wr" className={"widget widget-privacypolicy" + (props?.dark ? " bg-dark" : "")}>
        {props.children}
    </div>)
}

const PrivacyPolicyListWidget = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!props?.title && !props?.additional_text && !props?.descriptions && !props?.items) return null

    return (
        <Wrapper {...props}>
            <div className="container-xl row mx-auto p-0">
                <div className="col-12">
                    {props?.title ? <h3 data-test-id="privacypolicy-title" className={(props?.dark ? "text-white " : "") + "mb-4"}>{props.title}</h3> : null}
                    {props?.additional_text ? <p data-test-id="privacypolicy-ver" className={(props?.dark ? "text-white " : "") + "mb-4 text-medium text-sm-small"}>{props.additional_text}</p> : null}
                    {props?.descriptions ? <div data-test-id="privacypolicy-description" className={"editor mb-4" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.descriptions) }}></div> : null}
                </div>
                {
                    props?.items.map((item, index) => {
                        return (
                            <div key={index} className="col-12">
                                {item?.title ? <p data-test-id={"privacypolicy-el-title-" + index} className={(props?.dark ? "text-white " : "") + "text-medium text-sm-small text-bold mb-12"}>{item.title}</p> : null}
                                {item?.descriptions ? <div data-test-id={"privacypolicy-el-description-" + index} className={(item?.link !== undefined && item?.link?.length > 0 ? "mb-2 " : "mb-4 ") + "editor" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.descriptions) }}></div> : null}
                                {
                                    (item?.link !== undefined && item?.link?.length > 0) ?
                                        <button
                                            data-test-id={"privacypolicy-el-btn-" + index}
                                            type="button"
                                            onClick={() => {
                                                if (item?.link === '#link_cookies_customize_settings') {
                                                    const event = new Event('openCookiesPopup');
                                                    document.dispatchEvent(event)
                                                }
                                                else {
                                                    navigate(item.link);
                                                }
                                            }}
                                            className={"btn-cookies h-32 px-12 text-semibold mb-4" + (props?.dark ? " bg-dark" : "")}>
                                                {t('buttons.Cookies preference')}
                                        </button>
                                        : null
                                }
                            </div>
                        )
                    })
                }
            </div>
        </Wrapper>
    )
}

PrivacyPolicyListWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    items: PropTypes.array,
    className: PropTypes.string,
};

export default PrivacyPolicyListWidget;
